import React, { forwardRef } from 'react';
import { urlRegexValidator, FieldTypes } from 'utils/formUtils';
import DataTheoremMappingForm from './DataTheoremMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

export default forwardRef(function DataTheoremCredentialForm(props, ref){
    const fields = [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            rules: [urlRegexValidator],
        }, {
            name: "apiKey",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={DataTheoremMappingForm}
            initialValue={{apiEndpoint: "https://api.securetheorem.com"}}
            config={ props.config && { apiEndpoint: "https://api.securetheorem.com", ...props.config }}
        />
    )
})